export const indicators = {
  gdhi: "Global Digital Health Monitor",
  indicatorGuide: "Indicator Guide",
  paragraph1:
    "The <a class='link-blue' href='http://digitalhealthmonitor.org' target='_blank'>Global Digital Health Monitor (GDHM)</a> is an " +
    "interactive digital resource that tracks, monitors, and evaluates the use of digital technology for health across countries. GDHM uses " +
    "seven key indicator categories to track progress.",
  indicator: "Indicator",
  selected_indicator: "Selected Indicator",
};
